
import Reddit from "../../../assets/outline/Reddit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RedditIcon({ className, dataTestid = "RedditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Reddit data-testid={dataTestid} className={classes} {...rest} />
  );
}
